// extracted by mini-css-extract-plugin
module.exports = {"feedbackShare":"page-peticao-module--feedback-share--3S4RI","formTitle":"page-peticao-module--form-title--kLqYk","share":"page-peticao-module--share--2UMVt"};